import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/font-awesome-flag': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M444.4 359.4c0 7.2-6.1 10.2-13.3 13.3-28.7 12.3-59.4 23.6-92.2 23.6-46.1 0-67.6-28.7-122.9-28.7-39.9 0-81.9 14.3-115.7 29.7-2 1-4.1 1-6.1 2v77.8c0 21.4-16.1 34.8-33.8 34.8-19.5 0-34.8-15.4-34.8-34.8v-374.8c-13.3-10.2-22.5-26.6-22.5-45.1 0-31.7 25.6-57.3 57.3-57.3s57.3 25.6 57.3 57.3c0 18.4-8.2 34.8-22.5 45.1v31.7c4.1-1.4 58.8-28.7 114.7-28.7 65.3 0 97.7 27.6 127 27.6 38.9 0 81.9-27.6 92.2-27.6 8.2 0 15.4 6.1 15.4 13.3v240.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/font-awesome-flag.js
// module id = 832
// module chunks = 0